import React from "react";

const NoData = ({ text, image }) => {
  return (
    <div className="h-64 d-flex flex-column justify-content-center align-items-center">
      <img loading="lazy"  width={300} src={image || "/NoAddress.png"} alt="" />
      <p className="text-light-gray mt-4 fs-18 fw-semibold">{text}</p>
    </div>
  );
};

export default NoData;
